import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { t } from 'i18next';
import { ResponseApi } from '../BaseApi';
const employeeEventsSlice = createSlice({
    name: 'employeeEvents',
    initialState: {
        zonesList: [],
        allEmployees: [],
        selectedEmployees: [],
        emailPhoneSearchData: [],
        emailPhoneSearchList: [],
        normalEventDetails: {
            name: '',
            date: '',
            time: '',
            duration: '',
        },
        eventDetail: [],
        cancelEvent: [],
        companyRestrictionsData: [],
        readOnly: false,
        allFreeReservation: [],
        deleteEvents: [],
        getAllVisitorTypes:[],
        getVisitorTypeByID:[],
        getFreeShedules:[],
        getEventSetting: {},
        CreateFileEventSetting: {},
        getUserInvitations:[],
        groupInvitationsByEventId: [],
        getEventApprovalComments:[]
    },
    reducers: {
        updateAllEmployees: (state, action) => {
            state.allEmployees = action.payload;
        },
        updateSelectedEmployees: (state, action) => {
            state.selectedEmployees = [...state.selectedEmployees, ...action.payload];
        },
        SaveEmailPhoneSearchList: (state, action) => {
            state.emailPhoneSearchList = [...state.emailPhoneSearchList, action.payload];
        },
        updateEmailPhoneSearchList: (state, action) => {
            state.emailPhoneSearchList = action.payload;
        },
        setReadOnly: (state, { payload }) => {
            state.readOnly = payload;
        }
    },
    extraReducers: {
        'employeeEvents/getAllVisitorTypes/fulfilled': (state, action) => {
            state.getAllVisitorTypes = ResponseApi(action.payload);
        },
        'employeeEvents/getVisitorTypeByID/fulfilled': (state, action) => {
            state.getVisitorTypeByID = ResponseApi(action.payload);
        },
        'employeeEvents/zonesList/fulfilled': (state, action) => {
             state.zonesList = ResponseApi(action.payload);
        },
        'employeeEvents/allEmployees/fulfilled': (state, action) => {
            state.allEmployees = ResponseApi(action.payload);
        },

        'employeeEvents/allFreeReservation/fulfilled': (state, action) => {
            state.allFreeReservation = ResponseApi(action.payload);
        },
        'employeeEvents/searchByEmail/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};

            if (status >= 200 && status < 300) {
                state.emailPhoneSearchData = data;
                state.readOnly = true;
            } else if (status === 400) {
                // toast("Email not exists.please pre-register yourself.")
                state.readOnly = false;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },
        'employeeEvents/searchByPhone/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};

            if (status >= 200 && status < 300) {
                state.emailPhoneSearchData = data;
                state.readOnly = true;
            } else if (status === 400) {
                // toast("phone_number not exists.please pre-register yourself.")
                state.readOnly = false;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },
        'employeeEvents/getEventDetail/fulfilled': (state, action) => {
              state.eventDetail = ResponseApi(action.payload);
        },
        'employeeEvents/cancelEvent/fulfilled': (state, action) => {
           state.cancelEvent = ResponseApi(action.payload);
        },
        'employeeEvents/companyRestrictions/fulfilled': (state, action) => {
              state.companyRestrictionsData = ResponseApi(action.payload);
        },
        'employeeEvents/createVehicle/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast.success(t('has_been_created_successfully'));
                state.createVehicleData = data?.vehicle;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },
        'employeeEvents/preRegisterUser/fulfilled': (state, action) => {
            state.preRegisterUser = ResponseApi(action.payload);
        },
        'employeeEvents/deleteEvent/fulfilled': (state, action) => {
             state.deleteEvents = ResponseApi(action.payload);
        },
        'employeeEvents/getFreeShedules/fulfilled': (state, action) => {
             state.getFreeShedules = ResponseApi(action.payload);
        },
        'employeeEvents/getEventSetting/fulfilled': (state, action) => {
            state.getEventSetting = ResponseApi(action.payload);
        },
        'employeeEvents/CreateFileEventSetting/fulfilled': (state, action) => {
            state.CreateFileEventSetting = ResponseApi(action.payload)
        },
        'employeeEvents/getUserInvitations/fulfilled': (state, action) => {
            state.getUserInvitations = ResponseApi(action.payload);
        },
        'employeeEvents/groupInvitationsByEventId/fulfilled': (state, action) => {
            state.groupInvitationsByEventId = ResponseApi(action.payload);
        },
        'employeeEvents/getEventApprovalComments/fulfilled': (state, action) => {
            state.getEventApprovalComments = ResponseApi(action.payload);
        },
    },
});

export const {
    updateAllEmployees,
    updateSelectedEmployees,
    SaveEmailPhoneSearchList,
    updateEmailPhoneSearchList,
    setReadOnly,
} = employeeEventsSlice.actions;

export default employeeEventsSlice.reducer;
